import React from 'react';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { connect } from 'react-redux';

import WarningMessage from 'components/WarningMessage';
import { Grid } from 'semantic-ui-react';
import { makeSelectEntitiesWithMissingSpraySettings } from './selectors';
import { EntityDropdownOptions } from '../../types';

interface ConnectedProps {
    entitiesWithMissingSpraySettings: string[];
}

export interface OwnProps {
    options: EntityDropdownOptions;
}

export type Props = OwnProps & ConnectedProps;

export class SpraySchemaInnerEntityTableFieldWarningComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { entitiesWithMissingSpraySettings } = this.props;

        if (
            entitiesWithMissingSpraySettings &&
            entitiesWithMissingSpraySettings.length
        ) {
            const content = (
                <div style={{ whiteSpace: 'break-spaces' }}>
                    {entitiesWithMissingSpraySettings.join('\n')}
                </div>
            );

            const title =
                entitiesWithMissingSpraySettings.length > 1
                    ? 'Some areas could not be displayed as they are missing row spacing or total area (required fields for spray):'
                    : 'One area could not be displayed as it is missing row spacing or total area (required fields for spray):';

            return (
                <Grid.Row>
                    <Grid.Column>
                        <WarningMessage
                            title={title}
                            content={content}
                            visible
                        />
                    </Grid.Column>
                </Grid.Row>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entitiesWithMissingSpraySettings:
        makeSelectEntitiesWithMissingSpraySettings()
});

export default connect(mapStateToProps)(
    SpraySchemaInnerEntityTableFieldWarningComponent
);
